import { UnleashClient } from 'unleash-proxy-client'

export const FeatureFlags = new UnleashClient({
  appName: 'owner-hermes',
  clientKey: import.meta.env.VITE_UNLEASH_KEY,
  environment:
    import.meta.env.MODE === 'production' ? 'production' : 'development',
  url: 'https://us.app.unleash-hosted.com/usgg0011/api/frontend',
})

const FeatureFlagsPlugin = {
  install: function (Vue) {
    FeatureFlags.start()
    Vue.prototype.$featureFlags = FeatureFlags
  },
}

export default FeatureFlagsPlugin
